export default __webpack_public_path__ + "static/media/pirate-flag.179b9878.png";